import { render } from "./StandardScoreSettings.vue?vue&type=template&id=518d09f2&scoped=true"
import script from "./StandardScoreSettings.vue?vue&type=script&lang=js"
export * from "./StandardScoreSettings.vue?vue&type=script&lang=js"

import "./StandardScoreSettings.vue?vue&type=style&index=0&id=518d09f2&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518d09f2"]])

export default __exports__